import React from 'react'
import IconPng from 'atoms/IconPng'
import Icon from 'atoms/Icon'
import { Label } from 'atoms/Texts'
import NotifBtn from 'molecules/NotifBtn'
import { StyledHeader, StyledAvatar, NameContainer, MenuContainer } from './styles'
import { withTheme } from 'styled-components'
import { SERVER_URL } from 'fixtures/api'
import { isBase64DataURL } from 'helpers/imageHelper'

const icons = {
  ic_logout: require('App/assets/images/ic_logout.png'),
  ic_notif: require('App/assets/images/ic_notif.png'),
  ic_profile: require('App/assets/images/ic_profile.png')
}

const getAvatar = (userData) => {
  if (userData.hasOwnProperty('displayPictureUrl')) {
    return isBase64DataURL(userData.displayPictureUrl) ?  userData.displayPictureUrl : `${SERVER_URL}${userData.displayPictureUrl}`
  } else {
    return icons.ic_profile
  }
}

const Header = ({ theme, userLogin, fnLogout, fnShowNotif, fnShowMenu, viewState: { isMobileView } }) => {
  if (userLogin && userLogin.hasOwnProperty('userData')) {
    const { userData } = userLogin
    return (
      <StyledHeader isMobile={isMobileView}>
        {isMobileView &&
          <MenuContainer>
            <Icon icon={'bars'} ml={'0'} color={theme.mocaPurple} onClick={fnShowMenu} />
          </MenuContainer>
        }
        <NotifBtn fnShowNotif={fnShowNotif} />
        <StyledAvatar src={getAvatar(userData)} />
        <NameContainer>
          <Label mb={'0'}>
            {userData.displayName}
          </Label>
          <Label mb={'0'} lineheight={'14px'} size={'12px'} weight={'400'} color={theme.mocaGrey}>
            {userData.displayPosition}
          </Label>
        </NameContainer>
        <IconPng srcIcon={icons.ic_logout} ml={'37px'} size={'auto'} h={'17'} onClick={fnLogout} showPointer={true} />
      </StyledHeader>
    )
  } else return null
}

export default withTheme(Header)
